import type { RumBeforeSend } from '@datadog/browser-rum';

const PAGE_KINDS = [
  [/^\/$/, 'home'],
  [/^\/properties(?:\/|$)/, 'property'],
  [/^\/homes(?:\/|$)/, 'marketplace'],
  [/^\/(?:account|login|sign-in|reset-password)(?:\/|$)/, 'account'],
  [/^\/(?:checkout|buy-direct-checkout)(?:\/|$)/, 'checkout'],
  [/^\/articles(?:\/|$)/, 'article'],
  [/^\/sell(?:\/|$)/, 'sell'],
] as const;

function errorPageKind(viewUrl: string) {
  try {
    const { pathname } = new URL(viewUrl);
    return PAGE_KINDS.find(([pattern]) => pattern.test(pathname))?.[1] ?? 'other';
  } catch {
    return 'unknown';
  }
}

export const addRumErrorPageContext: RumBeforeSend = (event) => {
  if (event.type === 'error') {
    event.context = { ...event.context, errorPageKind: errorPageKind(event.view.url) };
  }
  return true;
};
